export default {
  defaultRobotsMetaTagValue: "index, follow",
}